import React, { useState } from "react";

const AttendanceLogCalendar = ({ onDateClick }) => {
  const today = new Date();
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [selectedDate, setSelectedDate] = useState(null);

  // Get number of days in a month
  const getDaysInMonth = (month, year) => {
    return new Date(year, month + 1, 0).getDate();
  };

  // Navigation handlers
  const handlePrevMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear((prev) => prev - 1);
    } else {
      setCurrentMonth((prev) => prev - 1);
    }
  };

  const handleNextMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear((prev) => prev + 1);
    } else {
      setCurrentMonth((prev) => prev + 1);
    }
  };

  const daysInMonth = getDaysInMonth(currentMonth, currentYear);
  const dates = [];

  for (let day = 1; day <= daysInMonth; day++) {
    const date = new Date(currentYear, currentMonth, day);
    const isSunday = date.getDay() === 0;
    const isToday =
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();
    const isSelected =
      selectedDate &&
      date.getDate() === selectedDate.getDate() &&
      date.getMonth() === selectedDate.getMonth() &&
      date.getFullYear() === selectedDate.getFullYear();

    dates.push({ day, isSunday, date, isToday, isSelected });
  }

  const handleDateClick = (date) => {
    if (!date.isSunday) {
      setSelectedDate(date.date);
      onDateClick(date.date);
    }
  };

  return (
    <div className="p-4 border rounded-xl shadow-sm w-full bg-white">
      {/* Header */}
      <div className="flex justify-between items-center mb-3">
        <button
          onClick={handlePrevMonth}
          className="p-1 rounded hover:bg-gray-100"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-5 h-5 text-[#de2b26]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
        <h2 className="text-lg font-semibold text-[#de2b26]">
          {new Date(currentYear, currentMonth).toLocaleString("default", {
            month: "long",
            year: "numeric",
          })}
        </h2>
        <button
          onClick={handleNextMonth}
          className="p-1 rounded hover:bg-gray-100"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-5 h-5 text-[#de2b26]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>

      {/* Dates in one line full width */}
      <div className="flex w-full">
        {dates.map((d) => (
          <button
            key={d.day}
            onClick={() => handleDateClick(d)}
            disabled={d.isSunday}
            className={`flex-1 h-12 flex items-center justify-center font-medium transition
              ${
                d.isSunday
                  ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                  : d.isSelected
                  ? "bg-[#de2b26] text-white font-bold"
                  : d.isToday
                  ? "border-[#de2b26] border-2"
                  : "bg-[#F9F4F1] text-[#840501] hover:bg-[#EADFD9] border border-gray-200"
              }
            `}
          >
            {d.day}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AttendanceLogCalendar;
